module.exports = __webpack_public_path__ + "img/mh1_icon.bc86da41.png";